import * as React from 'react'

/**
 * A custom hook that stores the previous value of a state or prop.
 *
 * @param {T} value - The current value of the state or prop.
 * @returns {React.MutableRefObject<T>} - A ref object with the previous value.
 *
 * @example
 * const [count, setCount] = useState(0);
 * const prevCount = usePrevious(count);
 */
function usePrevious<T>(value: T): React.MutableRefObject<T>{
	const ref = React.useRef<T>();
	React.useEffect(() => {
		ref.current = value;
	});

	return ref.current as React.MutableRefObject<T>;
}

export default usePrevious;
